import { Link } from "react-router-dom";
import { ApplicationSurface } from "../../../components/application";
import {
  authorizedExternalProjectLogo,
  projectFacilitationContextLabel,
} from "../utils/projectPresentation";
import ProjectCardPresentation from "./ProjectCardPresentation";

export default function ProjectFacilitationCard({ project }) {
  if (!project?.slug) return null;
  const logo = authorizedExternalProjectLogo(project);
  const contextLabel = projectFacilitationContextLabel(project);
  return (
    <ApplicationSurface as="article" className="av-project-facilitation-card" variant="nested">
      <div className="av-project-facilitation-card__content">
        <ProjectCardPresentation
          contextLabel={contextLabel}
          logo={logo}
          title={project.title}
        />
      </div>
      <div className="av-project-facilitation-card__actions">
        <Link className="av-app-button av-app-button--primary" to={`/app/facilitate/project/${project.slug}`}>
          Facilitate project
        </Link>
      </div>
    </ApplicationSurface>
  );
}
